module.exports = __webpack_public_path__ + "static/media/icon-clock.c3255041.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-clock.svg
// module id = 537
// module chunks = 0